// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","logo":"footer_logo__ke--D","div":"footer_div__kQw7z","p":"footer_p__UzN2Q"};